import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore.js'
import { useTenantStore } from '../stores/tenantStore.js'

/**
 * PublicLayout — the unauthenticated branch (/login, /callback, /deeplink).
 *
 * Fetches the public tenant config (theme, features, policy URLs) these
 * pages need without auth. The already-authenticated redirect deliberately
 * lives in LoginPage, not here: it must not preempt the /login?reset=1
 * escape hatch, and /callback completes its own flow while the store may
 * already read authenticated.
 */
export function PublicLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  useEffect(() => {
    const tenantStore = useTenantStore.getState()
    if (!isAuthenticated && !tenantStore.publicLoaded) {
      tenantStore.fetchPublicConfig()
    }
  }, [isAuthenticated])

  return <Outlet />
}
